import Back_Drop from "./Back_Drop";
const Loader={
     Back_Drop
}
export default Loader